module.exports = __webpack_public_path__ + "/images/screen-vendedores-marca.5f81b75.webp";